import React, { ReactNode } from 'react'
import { Link } from 'react-scroll'

interface SmoothScrollProps {
  className?: string
  href: string
  to: string
  children: ReactNode
  onClick?: VoidFunction
}

const SmoothScrollComponent = ({ children, className, href, onClick, to }: SmoothScrollProps) => {
  return (
    <Link className={className} to={to} href={href} onClick={onClick} smooth={true} duration={240} offset={-108}>
      {children}
    </Link>
  )
}

export default SmoothScrollComponent
